const modules = {};

export default class ImportUtils {
  static async getSwiper() {
    if ('swiper' in modules) {
      return modules.swiper;
    }
    const swiper = (await import(/* webpackChunkName: "Swiper" */ 'swiper')).default;
    modules.swiper = swiper;
    return modules.swiper;
  }
}
